import { useContext } from 'react'

import { GeoRuntimeContext } from './context'

export const useGeoRuntime = () => useContext(GeoRuntimeContext)
